import {
    getBankAccount,
    listBankAccounts
} from './queries';
import {
    createBankAccount,
    deleteBankAccount,
    updateBankAccount,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    BankAccount,
    CreateBankAccount,
    DeleteBankAccount,
    GetBankAccount,
    ListBankAccounts,
    UpdateBankAccount
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();

export const fetchRecords = async (customerId: string, limit?: number, nextToken?: string) => {

    const response = await client.graphql<GraphQLQuery<ListBankAccounts>>(
        {
            query: listBankAccounts,
            variables: {
                filter: {
                    customerId: customerId
                },
                limit,
                nextToken,
            },
        });
    return response.data?.listBankAccounts;
};

export const fetch = async (customerId: string, id: string) => {
    const response = await client.graphql<GraphQLQuery<GetBankAccount>>(
        {
            query: getBankAccount,
            variables: {
                customerId: customerId,
                id: id
            },
        });
    return response.data?.getBankAccount;
};

export const add = async (payload: object) => {

    const response = await client.graphql<GraphQLQuery<CreateBankAccount>>(
        {
            query: createBankAccount,
            variables: {
                input: payload
            },
        });

    return response.data?.createBankAccount;
};

export const update = async (record: BankAccount) => {

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateBankAccount>>(
        {
            query: (updateBankAccount),
            variables: {
                input: record
            },
        });
    return response.data?.updateBankAccount;
};

export const deleteRecord = async (customerId: string, id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteBankAccount>>(
        {
            query: (deleteBankAccount),
            variables: {
                input: {
                    customerId: customerId,
                    id: id
                }
            },

        });
    return response.data?.deleteBankAccount;
};
